export const getAvailableNumberOfSeats = (timeslots, startDate, endDate) => {
  if (!startDate || !timeslots || !endDate) {
    return 1;
  }

  // Get all the timeslots in a single array
  const allTimeSlots = Object.values(timeslots).flatMap(month => month.timeSlots);

  // Filter the timeslots to get only those intersecting with the interval
  const relevantTimeSlots = allTimeSlots.filter(slot => {
    const slotStartDate = new Date(slot?.attributes?.start);
    const slotEndDate = new Date(slot?.attributes?.end);

    // Two intervals intersect if the start of one is before the end of the other
    // and the end of one is after the start of the other
    return startDate <= slotEndDate && endDate >= slotStartDate;
  });

  // Find the minimum available seats among the relevant timeslots
  const maxSeats = Math.min(...relevantTimeSlots.map(slot => slot?.attributes?.seats));

  return maxSeats;
};
